import appAlignBottonSVG from './img/app-align-bottom.svg';
import appAlignHCenterSVG from './img/app-align-h-center.svg';
import appAlignLeftSVG from './img/app-align-left.svg';
import appAlignRightSVG from './img/app-align-right.svg';
import appAlignTextCenterSVG from './img/app-align-text-center.svg';
import appAlignTextLeftSVG from './img/app-align-text-left.svg';
import appAlignTexttRightSVG from './img/app-align-text-right.svg';
import appAlignTopSVG from './img/app-align-top.svg';
import appAlignVCenterSVG from './img/app-align-v-center.svg';
import appBoldSVG from './img/app-bold.svg';
import appcaretDownMini from './img/app-caret-down-mini.svg';
import appCropImageSVG from './img/app-crop-image.svg';
import appItalicSVG from './img/app-italic.svg';
import appLayerBackSVG from './img/app-layer-back.svg';
import appLayerForwardSVG from './img/app-layer-forward.svg';
import appLayerToBackSVG from './img/app-layer-to-back.svg';
import appLayerToFrontSVG from './img/app-layer-to-front.svg';
import appLockSVG from './img/app-lock.svg';
import appRedoSVG from './img/app-redo.svg';
import appUnderlineSVG from './img/app-underline.svg';
import appUndoSVG from './img/app-undo.svg';
export var AppIconsList = {
    'app-align-bottom': {
        src: appAlignBottonSVG,
        width: '16px',
        height: '15px',
    },
    'app-align-left': {
        src: appAlignLeftSVG,
        width: '15px',
        height: '16px',
    },
    'app-align-right': {
        src: appAlignRightSVG,
        width: '15px',
        height: '16px',
    },
    'app-align-top': {
        src: appAlignTopSVG,
        width: '16px',
        height: '15px',
    },
    'app-align-h-center': {
        src: appAlignHCenterSVG,
        width: '11px',
        height: '16px',
    },
    'app-align-v-center': {
        src: appAlignVCenterSVG,
        width: '16px',
        height: '11px',
    },
    'app-align-text-left': {
        src: appAlignTextLeftSVG,
        width: '12px',
        height: '11px',
    },
    'app-align-text-center': {
        src: appAlignTextCenterSVG,
        width: '12px',
        height: '11px',
    },
    'app-align-text-right': {
        src: appAlignTexttRightSVG,
        width: '12px',
        height: '11px',
    },
    'app-caret-down-mini': {
        src: appcaretDownMini,
        width: '8px',
        height: '14px',
    },
    'app-layer-back': {
        src: appLayerBackSVG,
        width: '7px',
        height: '12px',
    },
    'app-layer-forward': {
        src: appLayerForwardSVG,
        width: '7px',
        height: '12px',
    },
    'app-layer-to-back': {
        src: appLayerToBackSVG,
        width: '12px',
        height: '12px',
    },
    'app-layer-to-front': {
        src: appLayerToFrontSVG,
        width: '12px',
        height: '12px',
    },
    'app-lock': {
        src: appLockSVG,
        width: '8px',
        height: '12px',
    },
    'app-undo': {
        src: appUndoSVG,
        width: '12px',
        height: '12px',
    },
    'app-redo': {
        src: appRedoSVG,
        width: '12px',
        height: '12px',
    },
    'app-bold': {
        src: appBoldSVG,
        width: '12px',
        height: '11px',
    },
    'app-italic': {
        src: appItalicSVG,
        width: '12px',
        height: '11px',
    },
    'app-underline': {
        src: appUnderlineSVG,
        width: '12px',
        height: '11px',
    },
    'app-crop-image': {
        src: appCropImageSVG,
        width: '12px',
        height: '11px',
    },
};
//# sourceMappingURL=list.js.map